import { gql } from '@biletiniz/apollo';

export const LOGOUT = gql`
  mutation {
    logout {
      message
      status
    }
  }
`;
